import React, { useEffect, useState } from 'react';
import { FlameIcon } from 'lucide-react';
export function TopBanner() {
  const [timeLeft, setTimeLeft] = useState({
    hours: 23,
    minutes: 59,
    seconds: 59
  });
  useEffect(() => {
    const targetTime = new Date().getTime() + 24 * 60 * 60 * 1000;
    const interval = setInterval(() => {
      const now = new Date().getTime();
      const difference = targetTime - now;
      if (difference <= 0) {
        clearInterval(interval);
        setTimeLeft({
          hours: 0,
          minutes: 0,
          seconds: 0
        });
        return;
      }
      const hours = Math.floor(difference % (1000 * 60 * 60 * 24) / (1000 * 60 * 60));
      const minutes = Math.floor(difference % (1000 * 60 * 60) / (1000 * 60));
      const seconds = Math.floor(difference % (1000 * 60) / 1000);
      setTimeLeft({
        hours,
        minutes,
        seconds
      });
    }, 1000);
    return () => clearInterval(interval);
  }, []);
  const pad = (n: number) => n.toString().padStart(2, '0');
  return <div className="sticky top-0 z-50 bg-brand-accent text-white shadow-md" data-id="element-348">
      <div className="max-w-7xl mx-auto px-3 sm:px-6 py-2 md:py-2.5 flex items-center justify-center gap-2 md:gap-4" data-id="element-349">
        <FlameIcon className="w-4 h-4 md:w-5 md:h-5 text-yellow-300 flex-shrink-0 animate-pulse" data-id="element-350" />
        <span className="text-[11px] sm:text-sm md:text-base font-bold uppercase tracking-wide" data-id="element-351">
          <span className="hidden sm:inline" data-id="element-352">
            Oferta de lanzamiento termina en:
          </span>
          <span className="sm:hidden" data-id="element-353">Oferta termina en:</span>
        </span>
        <div className="flex items-center gap-1 md:gap-1.5 font-mono font-bold" data-id="element-354">
          <TimeBlock label="H" value={pad(timeLeft.hours)} data-id="element-355" />
          <span className="opacity-70" data-id="element-356">:</span>
          <TimeBlock label="M" value={pad(timeLeft.minutes)} data-id="element-357" />
          <span className="opacity-70" data-id="element-358">:</span>
          <TimeBlock label="S" value={pad(timeLeft.seconds)} data-id="element-359" />
        </div>
      </div>
    </div>;
}
function TimeBlock({
  value,
  label
}: {
  value: string;
  label: string;
}) {
  return <div className="bg-brand-dark px-1.5 md:px-2 py-0.5 md:py-1 rounded text-[11px] sm:text-sm md:text-base min-w-[26px] md:min-w-[32px] text-center" data-id="element-360">
      {value}
      <span className="ml-0.5 text-[9px] md:text-[10px] opacity-70" data-id="element-361">
        {label}
      </span>
    </div>;
}